/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_CuppingInputs */

const en_service_type_cupping = /** @type {(inputs: Service_Type_CuppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cupping`)
};

const pl_service_type_cupping = /** @type {(inputs: Service_Type_CuppingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bańki`)
};

/**
* | output |
* | --- |
* | "Cupping" |
*
* @param {Service_Type_CuppingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_cupping = /** @type {((inputs?: Service_Type_CuppingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_CuppingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_cupping(inputs)
	return en_service_type_cupping(inputs)
});